import { tuApptoAPI } from "../services/config";

const getHeaders = () => ({
  "x-token": sessionStorage.getItem("token"),
});

const base64ToBlob = (base64, contentType = "application/octet-stream") => {
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
    const slice = byteCharacters.slice(offset, offset + 1024);
    const byteNumbers = new Array(slice.length);

    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    byteArrays.push(new Uint8Array(byteNumbers));
  }

  return new Blob(byteArrays, { type: contentType });
};

const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result || "";
      resolve(result.toString().split(",").pop());
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export const downloadFile = async (url, key, callback) => {
  try {
    const response = await tuApptoAPI.post(
      "/documents/storage/get",
      { key },
      { headers: getHeaders() }
    );

    const blob = base64ToBlob(
      response.data.base64,
      response.data.contentType || "application/octet-stream"
    );
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = url;
    link.click();
    link.remove();

    if (typeof callback === "function") callback(response.data, null);
  } catch (error) {
    if (typeof callback === "function") callback(null, error);
  }
};

export const getFile = async (key, callback) => {
  try {
    const response = await tuApptoAPI.post(
      "/documents/storage/get",
      { key },
      { headers: getHeaders() }
    );

    if (typeof callback === "function") callback(response.data.base64, null);
  } catch (error) {
    if (typeof callback === "function") callback(null, error);
  }
};

export const uploadFile = async (key, body, callback) => {
  try {
    const fileBase64 = await fileToBase64(body);
    const response = await tuApptoAPI.post(
      "/documents/storage/upload",
      {
        key,
        fileBase64,
        contentType: body.type || "application/octet-stream",
      },
      { headers: getHeaders() }
    );

    if (typeof callback === "function") callback(response.data, null);
  } catch (error) {
    if (typeof callback === "function") callback(null, error);
  }
};
